var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sharingFriend"},[_c('img',{attrs:{"src":_vm.imgUrl,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }